  const generateSrcset = (image, widths = []) => {
    const imageUrl = new URL(image["src"]);
    return widths.filter((width) => width <= image["width"]).map((width) => {
      imageUrl.searchParams.set("width", width.toString());
      return `${imageUrl.href} ${width}w`;
    }).join(", ");
  }

  const createImageElement = (image, classes, sizes, productTitle) => {
    const previewImage = image["preview_image"];
    const newImage = new Image(previewImage["width"], previewImage["height"]);
    newImage.className = classes;
    newImage.alt = image["alt"] || productTitle;
    newImage.sizes = sizes;
    newImage.src = previewImage["src"];
    newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
    newImage.loading="lazy"
    return newImage;
  }

  const checkSwatches = () => {
    document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
      wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
        input.addEventListener('click', (event) => {
          const primaryImage = wrapper.querySelector(".media--first");
          const secondaryImage = wrapper.querySelector(".media--second");
          const handleProduct = wrapper.dataset.product;
          
          if (event.currentTarget.checked && primaryImage) {
            wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
            if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
              wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
              if (wrapper.querySelector('.card__add-to-cart button[name="add"] > span')) {
                wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
                wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
              }
              wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
            }
            
            const currentColor = event.currentTarget.value;

            jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
              const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];
              if (variant) {
                const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);
                
                if (newPrimaryImage.src !== primaryImage.src) {
                  let flag = false;
                  if (secondaryImage) {
                    const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                    const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                    if (secondaryImagePathname == newPrimaryImagePathname) {
                      primaryImage.remove();
                      secondaryImage.classList.remove('media--second');
                      secondaryImage.classList.add('media--first');
                      flag = true;
                    } 
                  }
                  if (flag == false) {
                    primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
                    setTimeout(function(){
                      primaryImage.replaceWith(newPrimaryImage);
                      newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
                      if (secondaryImage) {
                        secondaryImage.remove();                                    
                      }
                    }, 200);
                  }
                }
              }
            });
          }
        })
      })
    })
  }

  function colorSwatches() {
    checkSwatches();

    document.addEventListener('shopify:section:load', function () {
      checkSwatches();
    });
  }

  function initImageSwiper() {
    document.querySelectorAll('.product-card:not([data-swipe-init])').forEach(function(card) {
      var media = card.querySelector('.media.media--hover-effect');
      if (!media) return;
      var images = Array.from(media.querySelectorAll('img.media--swipe-item'));
      if (images.length <= 1) return;

      card.setAttribute('data-swipe-init', 'true');

      var dotsContainer = card.querySelector('.card-swipe-dots');
      var currentIndex = 0;

      // Build dots
      if (dotsContainer) {
        images.forEach(function(_, i) {
          var dot = document.createElement('span');
          dot.className = 'card-swipe-dot' + (i === 0 ? ' active' : '');
          dotsContainer.appendChild(dot);
        });
      }

      // Activate first image
      images[0].classList.add('media--swipe-active');

      function goTo(index) {
        var dots = dotsContainer ? dotsContainer.querySelectorAll('.card-swipe-dot') : [];
        images[currentIndex].classList.remove('media--swipe-active');
        if (dots[currentIndex]) dots[currentIndex].classList.remove('active');
        currentIndex = index;
        images[currentIndex].classList.add('media--swipe-active');
        if (dots[currentIndex]) dots[currentIndex].classList.add('active');
      }

      var startX, startY, swipeDirection;

      media.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        swipeDirection = null;
      }, { passive: true });

      media.addEventListener('touchmove', function(e) {
        if (swipeDirection === 'vertical') return;
        var dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;
        if (swipeDirection === null) {
          if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) {
            swipeDirection = 'horizontal';
          } else if (Math.abs(dy) > 8) {
            swipeDirection = 'vertical';
            return;
          } else {
            return;
          }
        }
        if (swipeDirection === 'horizontal') e.preventDefault();
      }, { passive: false });

      media.addEventListener('touchend', function(e) {
        if (swipeDirection !== 'horizontal') return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 30) {
          e.preventDefault();
          if (dx < 0 && currentIndex < images.length - 1) goTo(currentIndex + 1);
          else if (dx > 0 && currentIndex > 0) goTo(currentIndex - 1);
        }
      }, { passive: false });
    });
  }

  function imageSwiper() {
    initImageSwiper();
    document.addEventListener('shopify:section:load', function() {
      initImageSwiper();
    });
  }

(function () {
  colorSwatches();
  imageSwiper();
})()